/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ExpireGatewayMerchantDataRequest} from '@cash-web/protos/squareup/roster/gateway.pb'
import {ExpireGatewayMerchantDataResponse} from '@cash-web/protos/squareup/roster/gateway.pb'


export const expire = (request: ExpireGatewayMerchantDataRequest, options?: CashRequestOptions) => post<ExpireGatewayMerchantDataRequest, ExpireGatewayMerchantDataResponse>("/2.0/cash/expire", request, {...options, rejectOnError: true })